import 'virtual:legacy';
import './app.css';
import './ui/a11y.css';
/* скелетон и пиксельная сборка картинок: «Озвучка» и лица рядов Студии */
import './features/tts/pixel-reveal';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installHistoryRepeatBridge } from './bridge/history-repeat';
import { installFavoritesBridge } from './bridge/favorites';
import { setApiReady } from './api';
import { platform } from './platform';
import { bodyClass } from 'virtual:legacy';
import { allowsPrototypeTools } from './platform/server-mode';
import { installMetrika } from './platform/metrika';
import { installLowFx } from './platform/low-fx';

// Classic prototype scripts load after this module. They must share the same
// capability decision as React, before reading hashes or enabling simulators.
Object.defineProperty(window, '__steosPrototypeTools', {
  value: allowsPrototypeTools(), configurable: false, writable: false,
});

/* класс <body> прототипа — до вставки разметки каркаса: иначе его листы успевают встать без него и въезжают переходом transform */
document.body.className = bodyClass;

/* [ДЕМО] без адреса бэкенда (VITE_API_BASE) ответы даёт MSW; в production-сборку моки не входят.
   Моки запускаются перед первым запросом к API, не при загрузке */
if ((import.meta.env.DEV || import.meta.env.MODE === 'test') &&
    import.meta.env.VITE_MOCK_API === 'true' && !import.meta.env.VITE_API_BASE)
  setApiReady(() => import('./mocks/browser').then(m => m.startMocks()));

installLowFx();
platform.ready();
installHistoryRepeatBridge();
installFavoritesBridge();
installMetrika();

/* StrictMode не включается у корня-хозяина прототипа: каркас владеет DOM сам; у React-разделов он свой (src/bridge/page-module.tsx) */
createRoot(document.getElementById('root')!).render(<App />);
